import { createContext } from 'react'

import type { CommandPaletteSection } from './types'

export const HOME_ID = 'home'

export type CommandPaletteContextValue = {
  isOpen: boolean
  activeId: string
  search: string
  sections: CommandPaletteSection[]
  open: (sectionId?: string) => void
  close: () => void
  drillInto: (sectionId: string) => void
  back: () => void
  setSearch: (value: string) => void
  registerSection: (section: CommandPaletteSection) => void
  unregisterSection: (id: string) => void
}

export const CommandPaletteContext =
  createContext<CommandPaletteContextValue | null>(null)

export { HOME_ID as COMMAND_PALETTE_HOME_ID }
